'use strict';

import Balance from './leave/Balance.service'
import Category from './leave/Category.service'
const state = {}

const actions = {
  ...Balance.actions,
  ...Category.actions,
}

const mutations = {}

const getters = {}

export default { getters, actions, mutations, state }